<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('customers')"
      :columns="columns"
      resource_url="/loan/customer/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create_customer">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <customer-modal ref="customer_modal" @success="refresh_datatable" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date,
} from "@/utils";
import CustomerModal from "./customer_modal/Index.vue";

export default {
  name: "CustomerDataTable",
  components: { GenericTable, CustomerModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          data: (row) => {
            return `${row.first_name} ${row.last_name}`;
          },
        },
        {
          title: v.$t("email"),
          data: (row) => {
            return row.email || "-";
          },
        },
        {
          title: v.$t("phone"),
          data: (row) => {
            return row.phone || "-";
          },
        },
        {
          title: v.$t("address"),
          data: (row) => {
            return `${row.zip_code || ""} ${row.state || ""} ${row.city || ""}`;
          },
        },
        {
          title: v.$t("customer since"),
          data: (row) => {
            return format_date(row.create_date);
          },
        },
        {
          title: v.$t("actions"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.edit_customer(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure delete customer"),
                    v,
                    () => {
                      del("/loan/customer", { uuid: uuid })
                        .then(() => {
                          v.refresh_datatable();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create_customer() {
      this.$refs.customer_modal.show();
    },
    edit_customer(uuid) {
      this.$refs.customer_modal.show(uuid);
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh_datatable();
  },
};
</script>
